module.exports = __webpack_public_path__ + "img/20221209.455b882e.png";